
import Header from "../components/header.jsx";
import AdminSidebar from "../components/adminSidebar.jsx";
import AddOperator from "../components/adminAddOperator.jsx";
import Footer from "../components/footer.jsx";

function AddOperatorPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <AdminSidebar /> 
      < AddOperator/> 
    </div>
    <Footer /> 
  </div>

  );
}
export default AddOperatorPage;
